import { render, staticRenderFns } from "./Edityear.vue?vue&type=template&id=e76f5c66&"
import script from "./Edityear.vue?vue&type=script&lang=js&"
export * from "./Edityear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports